module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noDataAvailable":"No satisfaction data available."},"de":{"noDataAvailable":"Keine Zufriedenheitsdaten verfügbar."},"fr":{"noDataAvailable":"Aucune donnée de satisfaction disponible."},"it":{"noDataAvailable":"Nessun dato sulla soddisfazione disponibile."}}')
  delete Component.options._Ctor
}
